import _ from "lodash";

// Converts object keys from snake_case to camelCase. Not recursive.
export function camelizeKeys<T>(obj: T): T {
  if (!_.isObject(obj) || _.isArray(obj) || _.isDate(obj) || _.isNil(obj)) {
    return obj;
  }
  return _.mapKeys(obj, (_value, key) => {
    let camelizedKey = _.camelCase(key);
    if (camelizedKey.endsWith("Id")) {
      camelizedKey = `${camelizedKey.slice(0, -2)}ID`;
    }
    return camelizedKey;
  }) as T;
}

export function deepCamelizeKeys<T>(obj: T): T {
  if (_.isArray(obj)) {
    return obj.map((item) => deepCamelizeKeys(item)) as unknown as T;
  }
  if (_.isObject(obj) && !_.isDate(obj) && !_.isNil(obj)) {
    const camelizedObj = camelizeKeys(obj as object);
    Object.keys(camelizedObj).forEach((key) => {
      (camelizedObj as any)[key] = deepCamelizeKeys((camelizedObj as any)[key]);
    });
    return camelizedObj as T;
  }
  return obj;
}
